import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FilterListIcon from "@material-ui/icons/FilterList";
import { FormattedMessage } from "react-intl";
import { brandColors } from "../../theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleFilters: {
      display: "inline-block",
    },
    titleFiltersContent: {
      backgroundColor: brandColors.primary.main,
      color: "#ffffff",
      borderRadius: theme.spacing(0.5),
      alignItems: "center",
      display: "flex",
      justifyContent: "space-evenly",
      width: "90px",
      height: "25px",
    },
    text: {
      fontWeight: 500,
    },
  })
);

const FiltersTitle: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.titleFilters}>
      <div className={classes.titleFiltersContent}>
        <FilterListIcon />
        <Typography variant="button" component="div" className={classes.text}>
          <FormattedMessage id="exciseDutyView.transactionsView.filtersTitle" />
        </Typography>
      </div>
    </div>
  );
};

export default FiltersTitle;
